import script from "./FormRadioGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./FormRadioGroup.vue?vue&type=script&setup=true&lang=js"

import "./FormRadioGroup.vue?vue&type=style&index=0&id=509927d3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-509927d3"]])

export default __exports__